import React, { useState } from "react";

const TopCoinBanyUnit = (props) => {
  // const [activeTab, setActiveTab] = useState("tab_general_question");
  const [activeAccordion, setActiveAccordion] = useState("collapse_1");

  // const toggleTab = (tabId) => {
  //   setActiveTab(tabId);
  // };

  const toggleAccordion = (accordionId) => {
    setActiveAccordion(accordionId === activeAccordion ? "" : accordionId);
  };

  // Array of FAQ questions
  const faqQuestions = [
    {
      question: "How the mTopcoin System Works",
      answer:
        "At Topcoin, you earn free TopCoin every time you shop at a participating business, no sign-ups, no hassle. It all adds up in the background, and you’ll unlock real rewards as you go.",
    },
    {
      question: "What’s a mTopCoin?",
      answer: (
        <div>
          <p className="mb-0">Every time you spend money, you earn mTopCoin.</p>
          <p className="mb-1">
            For every 1p (one penny) you spend, you get 2 mTopCoin.
          </p>
          <h6 className="fw-semibold text-dark opacity-75">
            For example, if you spend:
          </h6>

          <ul>
            <li>£1 → You get 200 mTopCoin</li>
            <li>£2.50 → You get 500 mTopCoin</li>
            <li>
              £3 → You get 600 mTopCoin, which turns into 1 full Topcoin UK
            </li>
          </ul>
        </div>
      ),
    },
    {
      question: "600 mTopCoin = 1 Full Unit",
      answer: (
        <div>
          <p>
            As soon as your total mTopCoin reaches 600, they automatically
            convert into 1 full TopCoin .These full topcoin help you progress
            through your reward wallets and unlock eligible loyalty benefits.
          </p>
          <h6 className="fw-semibold text-dark opacity-75">For example: </h6>
          <ul>
            <li>Spend £2.99 → 599 mTopCoin</li>
            <li>
              Next time spend 1p → that makes 600 → you receive 1 full TopCoin
            </li>
          </ul>
          <p>
            Any remaining mTopCoin after a full topcoin is created stays in your
            account and continues building towards your next topcoin
          </p>
        </div>
      ),
    },
    {
      question: "Why It’s Great",
      answer: (
        <div>
          <h6 className="fw-semibold text-dark opacity-75">
            TopCoin UK rewards everyday spending with loyalty value that grows
            through participation in the system — not investment, trading, or
            speculation.{" "}
          </h6>
          <ul>
            <li>
              You receive loyalty rewards every time you shop at participating
              businesses
            </li>
            <li>
              Even small, everyday purchases help you progress through the
              reward system
            </li>
            <li>
              Everything happens automatically within the TopCoin UK platform
            </li>
            <li>
              The more TopCoin you collect, the more reward benefits you can
              unlock under the programme rules
            </li>
          </ul>

          <p>
            {" "}
            TopCoin UK is designed to reward regular shoppers through a
            structured loyalty programme. It is not an investment, financial
            service, or savings product.
          </p>
        </div>
      ),
    },
  ];
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div
          className="tab_block"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <div className="tab-content">
            {/* General Question Tab */}
            <div className="ico_accordion" id="accordion_1">
              {faqQuestions.map((item, index) => {
                const collapseId = `collapse_${index + 1}`;
                return (
                  <div className="accordion-item" key={collapseId}>
                    <div
                      className={`icon_arrow ${
                        activeAccordion === collapseId ? "collapsed" : ""
                      }`}
                      role="button"
                      onClick={() => toggleAccordion(collapseId)}
                    >
                      <svg
                        viewBox="0 0 23 27"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                        <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                        <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                      </svg>
                    </div>
                    <div
                      className={`accordion-button ${
                        activeAccordion === collapseId ? "" : "collapsed"
                      }`}
                      role="button"
                      onClick={() => toggleAccordion(collapseId)}
                    >
                      <h5 className="fw-semibold text-dark m-0 ">
                        {" "}
                        {`${index + 1}- ${item.question}`}
                      </h5>
                    </div>
                    <div
                      id={collapseId}
                      className={`accordion-collapse collapse ${
                        activeAccordion === collapseId ? "show" : ""
                      }`}
                      data-bs-parent="#accordion_1"
                    >
                      <div className="accordion-body">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopCoinBanyUnit;
